import oauth from "./oauth";

/**
 * 华博特项目接口文档
 */
export default {
  oauth,
};
